import { FC } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { BodyText, ButtonProps, Icon, Stack, useScreenSize } from '@servicetitan/design-system';
import { getNavClickHandler } from '../../utils/get-nav-click-handler';

import * as Styles from './navigation.module.less';

interface NavigationItemProps {
    to: string;
    name: string;
    iconName: ButtonProps['iconName'];
}

export const NavigationItem: FC<NavigationItemProps> = ({ to, iconName, name }) => {
    const screenSize = useScreenSize();

    const isSmall = screenSize.smallerThan.tablet;

    return (
        <NavLink to={to}>
            {({ isActive }) => (
                <Stack
                    spacing={1}
                    alignItems="center"
                    onClick={getNavClickHandler(isActive)}
                    className={classNames(Styles.navigationItem, {
                        [Styles.opacityHover]: !isActive,
                        [Styles.navigationItemActive]: isActive,
                    })}
                >
                    <Icon size={20} name={iconName} title={isSmall ? name : undefined} />
                    {!isSmall && <BodyText size="small">{name}</BodyText>}
                </Stack>
            )}
        </NavLink>
    );
};
